export const StarMark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <path
      d="M32 7 L37.4 26.6 L57 32 L37.4 37.4 L32 57 L26.6 37.4 L7 32 L26.6 26.6 Z"
      fill="currentColor"
    />
    <circle cx="32" cy="32" r="4.2" fill="#07090E" />
  </svg>
);

export default function Logo({ compact = false }) {
  return (
    <a
      href="#top"
      data-testid="brand-logo"
      onClick={(e) => {
        e.preventDefault();
        if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
        else window.scrollTo({ top: 0, behavior: "smooth" });
      }}
      className="group flex items-center gap-3"
      aria-label="Astra Consult home"
    >
      <span className="grid h-11 w-11 place-items-center overflow-hidden rounded-lg border border-white/10 bg-black transition-colors duration-300 group-hover:border-gold/50">
        <img src="/logo-mark.png" alt="Astra Consult logo" className="h-full w-full object-cover" />
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-display text-lg font-extrabold tracking-[0.08em] text-white">
          ASTRA
        </span>
        {!compact && (
          <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.32em] text-gold/80">
            Consult
          </span>
        )}
      </span>
    </a>
  );
}
